<template>
    <div id="menu" :class="{'sticky': isSticky}">
        <h1 @contextmenu="handleNexRightClick">NEXPLORA</h1>
        <div v-show="isSticky" class="mini-menu-btn" :class="{ open: isMenuOpen }" @click="isMenuOpen = !isMenuOpen">
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
        </div>
        <div v-show="isSticky" class="menu-btns" :class="{ 'menu-open': isMenuOpen }">
            <a class="submit" href="https://f.wps.cn/g/C18SodIN/" target="_blank" @click="isMenuOpen = false">提交产品</a>
            <a class="to-top" @click="scrollToTop">返回顶部</a>
            <div class="collapse" @click="isMenuOpen = false">收起</div>
        </div>
    </div>
    <div id="header">
        <div class="logo">
            <div class="platform">
                <img src="/RedditNew.png" style="margin-left: 2px;"/>
            </div>
            <div class="platform">
                <img src="/Product Hunt New.png" style="margin-left: 10px;" />
            </div>
            <div class="platform">
                <img src="/V2EXNew.png"  style="margin-left: 2px;"/>
            </div>
        </div>
        <h2>
            <BlurText
                text="探索始于好奇，发现终归这里"
                :delay="50"
                class-name="slogan"
                animate-by="words"
                direction="top"
                :step-duration="0.4"
            />
        </h2>
        <BlurText
            text="每天从V2EX、Reddit、Uneed等平台精挑细选值得尝试的新产品"
            :delay="50"
            animate-by="words"
            direction="top"
            :step-duration="0.4"
        />
        <FadeContent
            style="display: flex; flex-direction: column; align-items: center;"
            :blur="true"
            :duration="1000"
        >
            <div class="header-btns">
                    <div class="start-btn" @click="scrollToProductContainer" style="position: relative;">开始探索</div>
                    <a class="submit-btn" href="https://f.wps.cn/g/C18SodIN/" target="_blank">提交产品</a>
            </div>
            <transition name="fade" appear>
                <div class="new-products" v-if="newProducts.length > 0">
                    <div class="product-prefix">
                        <span>发现新</span>
                        <transition name="fade" mode="out-in">
                            <div class="product-category" :key="newProducts[currentIndex].category">
                                <i :class="newProducts[currentIndex].categoryIcon"></i>
                                <span>{{ newProducts[currentIndex].category }}</span>
                            </div>
                        </transition>
                        <span>产品</span>
                    </div>
                    <div class="products" :style="{ transform: `translateY(${-currentIndex * 100}%)` }">
                        <div class="product" v-for="(product, index) in newProducts" :key="index">
                            <img class="product-icon" :src="product.logo" loading="lazy" @error="onImageError" @load="onImageComplete" />
                            <div class="product-name">{{ product.name }}</div>
                            <div class="product-desc">:{{ product.description }}</div>
                        </div>
                    </div>
                </div>
            </transition>
        </FadeContent>
    </div>
    <!--<Prism
        animation-type="3drotate"
        :time-scale="0.4"
        :height="6"
        :base-width="10"
        :scale="4"
        :hue-shift="-0.8"
        :color-frequency="1.2"
        :noise="0"
        :glow="1"
        :suspendWhenOffscreen="true"
        style="position: absolute; top: 0; left: 0; z-index: 0;width: 100%; height: 100%;"
    />-->
    <div id="intro">
        <div class="feature">
            <FadeContent
                :blur="true"
                :duration="1000"
                :threshold="1"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
                    <title>实用精致</title>
                    <g fill="none">
                        <path d="M13 9.00531C13.5522 9.00531 13.9999 9.45308 14 10.0053V12.0053H16C16.5522 12.0053 16.9999 12.4531 17 13.0053C16.9998 13.5574 16.5521 14.0053 16 14.0053H14V16.0053C13.9998 16.5574 13.5521 17.0053 13 17.0053C12.4479 17.0053 12.0002 16.5574 12 16.0053V14.0053H10C9.44791 14.0053 9.00025 13.5574 9 13.0053C9.00007 12.4531 9.4478 12.0054 10 12.0053H12V10.0053C12.0001 9.45311 12.4478 9.00536 13 9.00531ZM6.07031 1.34125C6.4044 0.499912 7.59575 0.499853 7.92969 1.34125L9.25 4.66937C9.26453 4.70571 9.29373 4.73396 9.33008 4.74847L12.6592 6.07074C13.5005 6.40477 13.5005 7.59509 12.6592 7.92914L9.33008 9.2514C9.29374 9.2659 9.26454 9.29419 9.25 9.33051L7.92969 12.6586C7.59575 13.5 6.4044 13.5 6.07031 12.6586L4.74902 9.33051C4.73446 9.29418 4.70531 9.26588 4.66895 9.2514L1.34082 7.92914C0.49956 7.59509 0.49956 6.40479 1.34082 6.07074L4.66895 4.74847C4.70533 4.73399 4.73447 4.70572 4.74902 4.66937L6.07031 1.34125Z" fill="url(#1752500502803-7613136_sparkle_existing_0_mj429roqu)" data-glass="origin" mask="url(#1752500502803-7613136_sparkle_mask_90yh9c2fr)"></path>
                        <path d="M13 9.00531C13.5522 9.00531 13.9999 9.45308 14 10.0053V12.0053H16C16.5522 12.0053 16.9999 12.4531 17 13.0053C16.9998 13.5574 16.5521 14.0053 16 14.0053H14V16.0053C13.9998 16.5574 13.5521 17.0053 13 17.0053C12.4479 17.0053 12.0002 16.5574 12 16.0053V14.0053H10C9.44791 14.0053 9.00025 13.5574 9 13.0053C9.00007 12.4531 9.4478 12.0054 10 12.0053H12V10.0053C12.0001 9.45311 12.4478 9.00536 13 9.00531ZM6.07031 1.34125C6.4044 0.499912 7.59575 0.499853 7.92969 1.34125L9.25 4.66937C9.26453 4.70571 9.29373 4.73396 9.33008 4.74847L12.6592 6.07074C13.5005 6.40477 13.5005 7.59509 12.6592 7.92914L9.33008 9.2514C9.29374 9.2659 9.26454 9.29419 9.25 9.33051L7.92969 12.6586C7.59575 13.5 6.4044 13.5 6.07031 12.6586L4.74902 9.33051C4.73446 9.29418 4.70531 9.26588 4.66895 9.2514L1.34082 7.92914C0.49956 7.59509 0.49956 6.40479 1.34082 6.07074L4.66895 4.74847C4.70533 4.73399 4.73447 4.70572 4.74902 4.66937L6.07031 1.34125Z" fill="url(#1752500502803-7613136_sparkle_existing_0_mj429roqu)" data-glass="clone" filter="url(#1752500502803-7613136_sparkle_filter_alhgtlde0)" clip-path="url(#1752500502803-7613136_sparkle_clipPath_92n6igug9)"></path>
                        <path d="M16.6562 9.21226L14.3939 3.51196C13.893 2.24987 12.1067 2.24971 11.6056 3.51172L9.34194 9.21226C9.31834 9.27153 9.27153 9.31834 9.21226 9.34194L3.51085 11.6059C2.24896 12.107 2.24896 13.893 3.51085 14.3941L9.21226 16.6581C9.27153 16.6817 9.31834 16.7285 9.34194 16.7877L11.6055 22.4883C12.1067 23.7503 13.8929 23.7501 14.3939 22.488L16.6562 16.7877C16.6799 16.7283 16.7273 16.6816 16.7868 16.6581L22.4888 14.3941C23.7507 13.8931 23.7507 12.1069 22.4888 11.6059L16.7868 9.34194C16.7273 9.3184 16.6799 9.27173 16.6562 9.21226Z" fill="url(#1752500502803-7613136_sparkle_existing_1_itr2rlc6a)" data-glass="blur"></path>
                        <path d="M11.6054 3.51174C12.1064 2.24985 13.8924 2.24997 14.3934 3.51174L16.6561 9.21194C16.6798 9.27141 16.7275 9.31828 16.787 9.34182L22.4882 11.6055C23.7501 12.1065 23.7501 13.8935 22.4882 14.3946L16.787 16.6582L16.745 16.6797C16.7052 16.7056 16.6739 16.7433 16.6561 16.7881L14.3934 22.4883L14.3427 22.6026C13.8 23.7118 12.1987 23.712 11.6561 22.6026L11.6054 22.4883L9.34168 16.7881C9.31809 16.7288 9.27106 16.6818 9.2118 16.6582L3.51063 14.3946C2.24874 13.8935 2.24874 12.1066 3.51063 11.6055L9.2118 9.34182C9.27106 9.31822 9.31809 9.2712 9.34168 9.21194L11.6054 3.51174ZM13.6972 3.78909C13.4468 3.15817 12.5534 3.15751 12.3026 3.78811L10.0389 9.48928C9.95156 9.70875 9.78837 9.88881 9.58094 9.99709L9.48914 10.0391L3.78797 12.3028C3.15702 12.5533 3.15703 13.4467 3.78797 13.6973L9.48914 15.961C9.70861 16.0483 9.88867 16.2115 9.99695 16.419L10.0389 16.5108L12.3026 22.2119C12.5534 22.8425 13.4458 22.8419 13.6962 22.211L15.9589 16.5108L16.0018 16.418C16.1117 16.2083 16.293 16.047 16.5097 15.961L22.2118 13.6973C22.8428 13.4468 22.8428 12.5533 22.2118 12.3028L16.5097 10.0391V10.0381C16.2931 9.95206 16.1116 9.79167 16.0018 9.58205L15.9589 9.48928L13.6972 3.78909Z" fill="url(#1752500502803-7613136_sparkle_existing_2_7lj7nb2b2)"></path>
                        <defs>
                        <linearGradient id="1752500502803-7613136_sparkle_existing_0_mj429roqu" x1="8.855" y1=".71" x2="8.855" y2="13.5" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#5e5c56"></stop>
                            <stop offset="1" stop-color="#1f1f1f"></stop>
                        </linearGradient>
                        <linearGradient id="1752500502803-7613136_sparkle_existing_1_itr2rlc6a" x1="13" y1="0" x2="13" y2="26" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#ffe55c" stop-opacity="1"></stop>
                            <stop offset="1" stop-color="#fff9e6" stop-opacity="1"></stop>
                        </linearGradient>
                        <filter id="1752500502803-7613136_sparkle_filter_alhgtlde0" x="-100%" y="-100%" width="400%" height="400%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse">
                            <feGaussianBlur stdDeviation="2" x="0%" y="0%" width="100%" height="100%" in="SourceGraphic" edgeMode="none" result="blur"></feGaussianBlur>
                        </filter>
                        <clipPath id="1752500502803-7613136_sparkle_clipPath_92n6igug9">
                            <path d="M16.6562 9.21226L14.3939 3.51196C13.893 2.24987 12.1067 2.24971 11.6056 3.51172L9.34194 9.21226C9.31834 9.27153 9.27153 9.31834 9.21226 9.34194L3.51085 11.6059C2.24896 12.107 2.24896 13.893 3.51085 14.3941L9.21226 16.6581C9.27153 16.6817 9.31834 16.7285 9.34194 16.7877L11.6055 22.4883C12.1067 23.7503 13.8929 23.7501 14.3939 22.488L16.6562 16.7877C16.6799 16.7283 16.7273 16.6816 16.7868 16.6581L22.4888 14.3941C23.7507 13.8931 23.7507 12.1069 22.4888 11.6059L16.7868 9.34194C16.7273 9.3184 16.6799 9.27173 16.6562 9.21226Z" fill="url(#1752500502803-7613136_sparkle_existing_1_itr2rlc6a)"></path>
                        </clipPath>
                        <mask id="1752500502803-7613136_sparkle_mask_90yh9c2fr">
                            <rect width="100%" height="100%" fill="#FFF"></rect>
                            <path d="M16.6562 9.21226L14.3939 3.51196C13.893 2.24987 12.1067 2.24971 11.6056 3.51172L9.34194 9.21226C9.31834 9.27153 9.27153 9.31834 9.21226 9.34194L3.51085 11.6059C2.24896 12.107 2.24896 13.893 3.51085 14.3941L9.21226 16.6581C9.27153 16.6817 9.31834 16.7285 9.34194 16.7877L11.6055 22.4883C12.1067 23.7503 13.8929 23.7501 14.3939 22.488L16.6562 16.7877C16.6799 16.7283 16.7273 16.6816 16.7868 16.6581L22.4888 14.3941C23.7507 13.8931 23.7507 12.1069 22.4888 11.6059L16.7868 9.34194C16.7273 9.3184 16.6799 9.27173 16.6562 9.21226Z" fill="#000"></path>
                        </mask>
                        </defs>
                    </g>
                </svg>
                <h3>实用精致</h3>
                <span class="subtitle">不将就功能，也不亏待颜值</span>
            </FadeContent>
        </div>
        <div class="feature">
            <FadeContent
                :blur="true"
                :duration="1000"
                :delay="200"
                :threshold="1"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
                    <title>人工挑选</title>
                    <g fill="none">
                        <path d="M10.586 10.5859C11.3671 9.80486 12.6331 9.80486 13.4142 10.5859L21.9142 19.0859L22.0519 19.2373C22.6926 20.0228 22.6464 21.1818 21.9142 21.914C21.1819 22.6463 20.0229 22.6925 19.2374 22.0517L19.086 21.914L10.586 13.414C9.80498 12.633 9.80498 11.367 10.586 10.5859Z" fill="url(#1752500502796-6054278_magnifier_existing_0_gpzbpr1b3)" data-glass="origin" mask="url(#1752500502796-6054278_magnifier_mask_u1j50qeck)"></path>
                        <path d="M10.586 10.5859C11.3671 9.80486 12.6331 9.80486 13.4142 10.5859L21.9142 19.0859L22.0519 19.2373C22.6926 20.0228 22.6464 21.1818 21.9142 21.914C21.1819 22.6463 20.0229 22.6925 19.2374 22.0517L19.086 21.914L10.586 13.414C9.80498 12.633 9.80498 11.367 10.586 10.5859Z" fill="url(#1752500502796-6054278_magnifier_existing_0_gpzbpr1b3)" data-glass="clone" filter="url(#1752500502796-6054278_magnifier_filter_u6qjvmab1)" clip-path="url(#1752500502796-6054278_magnifier_clipPath_k96ejzfu8)"></path>
                        <path d="M18.5 10C18.5 14.6943 14.6943 18.5 10 18.5C5.30567 18.5 1.5 14.6943 1.5 10C1.5 5.30567 5.30567 1.5 10 1.5C14.6943 1.5 18.5 5.30567 18.5 10Z" fill="url(#1752500502796-6054278_magnifier_existing_1_82nwa6xrf)" data-glass="blur"></path>
                        <path d="M17.75 10C17.75 5.71989 14.2801 2.25 10 2.25C5.71989 2.25 2.25 5.71989 2.25 10C2.25 14.2801 5.71989 17.75 10 17.75V18.5C5.30567 18.5 1.5 14.6943 1.5 10C1.5 5.30567 5.30567 1.5 10 1.5C14.6943 1.5 18.5 5.30567 18.5 10C18.5 14.6943 14.6943 18.5 10 18.5V17.75C14.2801 17.75 17.75 14.2801 17.75 10Z" fill="url(#1752500502796-6054278_magnifier_existing_2_8ve8k2etb)"></path>
                        <defs>
                        <linearGradient id="1752500502796-6054278_magnifier_existing_0_gpzbpr1b3" x1="16.25" y1="10" x2="16.25" y2="22.5" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#5e5c56"></stop>
                            <stop offset="1" stop-color="#1f1f1f"></stop>
                        </linearGradient>
                        <linearGradient id="1752500502796-6054278_magnifier_existing_1_82nwa6xrf" x1="10" y1="1.5" x2="10" y2="18.5" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#ffe55c" stop-opacity="1"></stop>
                            <stop offset="1" stop-color="#fff9e6" stop-opacity="1"></stop>
                        </linearGradient>
                        <filter id="1752500502796-6054278_magnifier_filter_u6qjvmab1" x="-100%" y="-100%" width="400%" height="400%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse">
                            <feGaussianBlur stdDeviation="2" x="0%" y="0%" width="100%" height="100%" in="SourceGraphic" edgeMode="none" result="blur"></feGaussianBlur>
                        </filter>
                        <clipPath id="1752500502796-6054278_magnifier_clipPath_k96ejzfu8">
                            <path d="M18.5 10C18.5 14.6943 14.6943 18.5 10 18.5C5.30567 18.5 1.5 14.6943 1.5 10C1.5 5.30567 5.30567 1.5 10 1.5C14.6943 1.5 18.5 5.30567 18.5 10Z" fill="url(#1752500502796-6054278_magnifier_existing_1_82nwa6xrf)"></path>
                        </clipPath>
                        <mask id="1752500502796-6054278_magnifier_mask_u1j50qeck">
                            <rect width="100%" height="100%" fill="#FFF"></rect>
                            <path d="M18.5 10C18.5 14.6943 14.6943 18.5 10 18.5C5.30567 18.5 1.5 14.6943 1.5 10C1.5 5.30567 5.30567 1.5 10 1.5C14.6943 1.5 18.5 5.30567 18.5 10Z" fill="#000"></path>
                        </mask>
                        </defs>
                    </g>
                </svg>
                <h3>人工挑选</h3>
                <span class="subtitle">古法人工体验，减少粗制滥造</span>
            </FadeContent>
        </div>
        <div class="feature">
            <FadeContent
                :blur="true"
                :duration="1000"
                :delay="400"
                :threshold="1"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
                    <title>每天更新</title>
                    <g fill="none">
                        <path d="M12 17C12.5523 17 13 17.4477 13 18V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V18C11 17.4477 11.4477 17 12 17ZM4.10352 18.543C4.49402 18.1525 5.12706 18.1525 5.51758 18.543C5.90809 18.9335 5.90808 19.5665 5.51758 19.957L4.70703 20.7676C4.31651 21.1581 3.68349 21.1581 3.29297 20.7676C2.90251 20.377 2.90246 19.744 3.29297 19.3535L4.10352 18.543ZM18.5693 18.543C18.9598 18.1525 19.5929 18.1526 19.9834 18.543L20.7949 19.3535C21.1852 19.744 21.1851 20.3771 20.7949 20.7676C20.4044 21.1581 19.7704 21.1581 19.3799 20.7676L18.5693 19.957C18.1791 19.5666 18.1791 18.9334 18.5693 18.543ZM13 4.06152C16.6186 4.51276 19.4842 7.38143 19.9355 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H19.9355C19.4842 16.6186 16.6186 19.4872 13 19.9385C15.667 13.8172 15.5982 10.3268 13 4.06152ZM6 11C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13H1C0.447715 13 2.41411e-08 12.5523 0 12C-5.17737e-10 11.4477 0.447715 11 1 11H6ZM12 0C12.5523 0 13 0.447715 13 1V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V1C11 0.447715 11.4477 0 12 0ZM3.2666 3.26855C3.65713 2.87811 4.29017 2.87806 4.68066 3.26855L5.49121 4.0791C5.88153 4.46961 5.8816 5.10269 5.49121 5.49316C5.10075 5.88363 4.46769 5.88351 4.07715 5.49316L3.2666 4.68262C2.87608 4.29209 2.87608 3.65908 3.2666 3.26855ZM19.3535 3.26855C19.744 2.87803 20.3771 2.87803 20.7676 3.26855C21.1581 3.65908 21.1581 4.29211 20.7676 4.68262L19.957 5.49316C19.5665 5.88362 18.9335 5.88362 18.543 5.49316C18.1525 5.10266 18.1525 4.46963 18.543 4.0791L19.3535 3.26855Z" fill="url(#1752671328337-5032557_brightness-increase_existing_0_49igrncce)" data-glass="origin" mask="url(#1752671328337-5032557_brightness-increase_mask_65rpgn8v4)"></path>
                        <path d="M12 17C12.5523 17 13 17.4477 13 18V23C13 23.5523 12.5523 24 12 24C11.4477 24 11 23.5523 11 23V18C11 17.4477 11.4477 17 12 17ZM4.10352 18.543C4.49402 18.1525 5.12706 18.1525 5.51758 18.543C5.90809 18.9335 5.90808 19.5665 5.51758 19.957L4.70703 20.7676C4.31651 21.1581 3.68349 21.1581 3.29297 20.7676C2.90251 20.377 2.90246 19.744 3.29297 19.3535L4.10352 18.543ZM18.5693 18.543C18.9598 18.1525 19.5929 18.1526 19.9834 18.543L20.7949 19.3535C21.1852 19.744 21.1851 20.3771 20.7949 20.7676C20.4044 21.1581 19.7704 21.1581 19.3799 20.7676L18.5693 19.957C18.1791 19.5666 18.1791 18.9334 18.5693 18.543ZM13 4.06152C16.6186 4.51276 19.4842 7.38143 19.9355 11H23C23.5523 11 24 11.4477 24 12C24 12.5523 23.5523 13 23 13H19.9355C19.4842 16.6186 16.6186 19.4872 13 19.9385C15.667 13.8172 15.5982 10.3268 13 4.06152ZM6 11C6.55228 11 7 11.4477 7 12C7 12.5523 6.55228 13 6 13H1C0.447715 13 2.41411e-08 12.5523 0 12C-5.17737e-10 11.4477 0.447715 11 1 11H6ZM12 0C12.5523 0 13 0.447715 13 1V6C13 6.55228 12.5523 7 12 7C11.4477 7 11 6.55228 11 6V1C11 0.447715 11.4477 0 12 0ZM3.2666 3.26855C3.65713 2.87811 4.29017 2.87806 4.68066 3.26855L5.49121 4.0791C5.88153 4.46961 5.8816 5.10269 5.49121 5.49316C5.10075 5.88363 4.46769 5.88351 4.07715 5.49316L3.2666 4.68262C2.87608 4.29209 2.87608 3.65908 3.2666 3.26855ZM19.3535 3.26855C19.744 2.87803 20.3771 2.87803 20.7676 3.26855C21.1581 3.65908 21.1581 4.29211 20.7676 4.68262L19.957 5.49316C19.5665 5.88362 18.9335 5.88362 18.543 5.49316C18.1525 5.10266 18.1525 4.46963 18.543 4.0791L19.3535 3.26855Z" fill="url(#1752671328337-5032557_brightness-increase_existing_0_49igrncce)" data-glass="clone" filter="url(#1752671328337-5032557_brightness-increase_filter_d8ycux4s0)" clip-path="url(#1752671328337-5032557_brightness-increase_clipPath_28dxykj4c)"></path>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z" fill="url(#1752671328337-5032557_brightness-increase_existing_1_6oholp3iv)" data-glass="blur"></path>
                        <path d="M19.25 12C19.25 7.99594 16.0041 4.75 12 4.75C7.99594 4.75 4.75 7.99594 4.75 12C4.75 16.0041 7.99594 19.25 12 19.25V20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20V19.25C16.0041 19.25 19.25 16.0041 19.25 12Z" fill="url(#1752671328337-5032557_brightness-increase_existing_2_352xq45op)"></path>
                        <defs>
                        <linearGradient id="1752671328337-5032557_brightness-increase_existing_0_49igrncce" x1="12" y1="0" x2="12" y2="24" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#5e5c56"></stop>
                            <stop offset="1" stop-color="#1f1f1f"></stop>
                        </linearGradient>
                        <linearGradient id="1752671328337-5032557_brightness-increase_existing_1_6oholp3iv" x1="12" y1="4" x2="12" y2="20" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#ffe55c" stop-opacity="1"></stop>
                            <stop offset="1" stop-color="#fff9e6" stop-opacity="1"></stop>
                        </linearGradient>
                        <filter id="1752671328337-5032557_brightness-increase_filter_d8ycux4s0" x="-100%" y="-100%" width="400%" height="400%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse">
                            <feGaussianBlur stdDeviation="2" x="0%" y="0%" width="100%" height="100%" in="SourceGraphic" edgeMode="none" result="blur"></feGaussianBlur>
                        </filter>
                        <clipPath id="1752671328337-5032557_brightness-increase_clipPath_28dxykj4c">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z" fill="url(#1752671328337-5032557_brightness-increase_existing_1_6oholp3iv)"></path>
                        </clipPath>
                        <mask id="1752671328337-5032557_brightness-increase_mask_65rpgn8v4">
                            <rect width="100%" height="100%" fill="#FFF"></rect>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4Z" fill="#000"></path>
                        </mask>
                        </defs>
                    </g>
                </svg>
                <h3 class="feature-3">每天更新</h3>
                <span class="subtitle">让发现成为习惯，保持探索节奏</span>
            </FadeContent>
        </div>
        <div class="feature">
            <FadeContent
                :blur="true"
                :duration="1000"
                :delay="600"
                :threshold="1"
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24">
                    <title>多源发掘</title>
                    <g fill="none">
                        <path d="M9.12015 8.16C10.1529 7.38542 10.6693 6.99813 11.2364 6.84884C11.737 6.71706 12.2632 6.71705 12.7638 6.84883C13.331 6.99812 13.8474 7.38541 14.8801 8.15999L20.5868 12.44C21.7448 13.3085 22.3238 13.7427 22.5308 14.275C22.7122 14.7413 22.7122 15.2586 22.5308 15.7249C22.3238 16.2573 21.7448 16.6915 20.5868 17.56L14.8801 21.84C13.8474 22.6146 13.331 23.0019 12.7638 23.1512C12.2632 23.2829 11.737 23.2829 11.2364 23.1512C10.6693 23.0019 10.1529 22.6146 9.12014 21.84L3.41349 17.56C2.25552 16.6915 1.67654 16.2573 1.4695 15.7249C1.28816 15.2586 1.28816 14.7413 1.46951 14.275C1.67655 13.7427 2.25553 13.3085 3.41349 12.44L9.12015 8.16Z" fill="url(#1752500502793-639649_layers_existing_0_b0rh2cs4r)" data-glass="origin" mask="url(#1752500502793-639649_layers_mask_lh5t9hjjm)"></path>
                        <path d="M9.12015 8.16C10.1529 7.38542 10.6693 6.99813 11.2364 6.84884C11.737 6.71706 12.2632 6.71705 12.7638 6.84883C13.331 6.99812 13.8474 7.38541 14.8801 8.15999L20.5868 12.44C21.7448 13.3085 22.3238 13.7427 22.5308 14.275C22.7122 14.7413 22.7122 15.2586 22.5308 15.7249C22.3238 16.2573 21.7448 16.6915 20.5868 17.56L14.8801 21.84C13.8474 22.6146 13.331 23.0019 12.7638 23.1512C12.2632 23.2829 11.737 23.2829 11.2364 23.1512C10.6693 23.0019 10.1529 22.6146 9.12014 21.84L3.41349 17.56C2.25552 16.6915 1.67654 16.2573 1.4695 15.7249C1.28816 15.2586 1.28816 14.7413 1.46951 14.275C1.67655 13.7427 2.25553 13.3085 3.41349 12.44L9.12015 8.16Z" fill="url(#1752500502793-639649_layers_existing_0_b0rh2cs4r)" data-glass="clone" filter="url(#1752500502793-639649_layers_filter_kkalz5ssh)" clip-path="url(#1752500502793-639649_layers_clipPath_il5y28du5)"></path>
                        <path d="M9.12015 2.15999C10.1529 1.38542 10.6693 0.998128 11.2364 0.848835C11.737 0.717055 12.2632 0.717055 12.7638 0.848834C13.331 0.998124 13.8474 1.38541 14.8801 2.15999L20.5868 6.43998C21.7448 7.30845 22.3238 7.74269 22.5308 8.27503C22.7122 8.74132 22.7122 9.25864 22.5308 9.72492C22.3238 10.2573 21.7448 10.6915 20.5868 11.56L14.8801 15.84C13.8474 16.6146 13.331 17.0019 12.7638 17.1512C12.2632 17.2829 11.737 17.2829 11.2364 17.1512C10.6693 17.0019 10.1529 16.6146 9.12014 15.84L3.41349 11.56C2.25552 10.6915 1.67654 10.2573 1.4695 9.72492C1.28816 9.25864 1.28816 8.74132 1.46951 8.27504C1.67655 7.74269 2.25553 7.30846 3.41349 6.43998L9.12015 2.15999Z" fill="url(#1752500502793-639649_layers_existing_1_b23jvecwf)" data-glass="blur"></path>
                        <path d="M11.237 0.848781C11.7375 0.717108 12.2639 0.717038 12.7644 0.848781C13.3314 0.998119 13.8479 1.38584 14.8806 2.1603L20.5866 6.44056C21.7446 7.30903 22.3239 7.74317 22.5309 8.27552C22.7121 8.74164 22.7121 9.25861 22.5309 9.72473C22.3239 10.2571 21.7446 10.6912 20.5866 11.5597L14.8806 15.8399L14.194 16.3507C13.5865 16.7934 13.1897 17.0395 12.7644 17.1515L12.5749 17.1944C12.1953 17.2685 11.805 17.2685 11.4255 17.1944L11.237 17.1515C10.8117 17.0395 10.4147 16.7933 9.80733 16.3507L9.12081 15.8399L3.4138 11.5597C2.25593 10.6913 1.67649 10.2571 1.46947 9.72473C1.31093 9.31688 1.29097 8.86987 1.4099 8.45227L1.46947 8.27552C1.62471 7.87635 1.98934 7.53197 2.65013 7.01868L3.4138 6.44056L9.12081 2.1603C10.0243 1.48266 10.5323 1.10089 11.0251 0.916164L11.237 0.848781ZM12.5729 1.57436C12.1975 1.47557 11.8029 1.47554 11.4274 1.57436C11.0366 1.67728 10.6561 1.94538 9.57003 2.75991L3.86399 7.04017C3.27389 7.48274 2.87129 7.78513 2.58665 8.04114C2.30554 8.29399 2.20972 8.44147 2.16868 8.547C2.05534 8.83843 2.05534 9.16182 2.16868 9.45325C2.20973 9.55878 2.30557 9.70629 2.58665 9.95911C2.87129 10.2151 3.27391 10.5175 3.86399 10.9601L9.57003 15.2403C10.6561 16.0549 11.0366 16.323 11.4274 16.4259C11.8029 16.5247 12.1975 16.5247 12.5729 16.4259C12.9638 16.323 13.3443 16.0549 14.4304 15.2403L20.1374 10.9601C20.7272 10.5177 21.1292 10.215 21.4137 9.95911C21.6947 9.70637 21.7906 9.55877 21.8317 9.45325C21.945 9.16182 21.945 8.83843 21.8317 8.547C21.7906 8.44148 21.6948 8.2939 21.4137 8.04114C21.1292 7.7852 20.7272 7.48254 20.1374 7.04017L14.4304 2.75991C13.3443 1.94534 12.9638 1.67725 12.5729 1.57436Z" fill="url(#1752500502793-639649_layers_existing_2_j9tnotxte)"></path>
                        <defs>
                        <linearGradient id="1752500502793-639649_layers_existing_0_b0rh2cs4r" x1="12" y1="6.75" x2="12" y2="23.25" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#5e5c56"></stop>
                            <stop offset="1" stop-color="#1f1f1f"></stop>
                        </linearGradient>
                        <linearGradient id="1752500502793-639649_layers_existing_1_b23jvecwf" x1="12" y1=".75" x2="12" y2="17.25" gradientUnits="userSpaceOnUse">
                            <stop stop-color="#ffe55c" stop-opacity="1"></stop>
                            <stop offset="1" stop-color="#fff9e6" stop-opacity="1"></stop>
                        </linearGradient>
                        <filter id="1752500502793-639649_layers_filter_kkalz5ssh" x="-100%" y="-100%" width="400%" height="400%" filterUnits="objectBoundingBox" primitiveUnits="userSpaceOnUse">
                            <feGaussianBlur stdDeviation="2" x="0%" y="0%" width="100%" height="100%" in="SourceGraphic" edgeMode="none" result="blur"></feGaussianBlur>
                        </filter>
                        <clipPath id="1752500502793-639649_layers_clipPath_il5y28du5">
                            <path d="M9.12015 2.15999C10.1529 1.38542 10.6693 0.998128 11.2364 0.848835C11.737 0.717055 12.2632 0.717055 12.7638 0.848834C13.331 0.998124 13.8474 1.38541 14.8801 2.15999L20.5868 6.43998C21.7448 7.30845 22.3238 7.74269 22.5308 8.27503C22.7122 8.74132 22.7122 9.25864 22.5308 9.72492C22.3238 10.2573 21.7448 10.6915 20.5868 11.56L14.8801 15.84C13.8474 16.6146 13.331 17.0019 12.7638 17.1512C12.2632 17.2829 11.737 17.2829 11.2364 17.1512C10.6693 17.0019 10.1529 16.6146 9.12014 15.84L3.41349 11.56C2.25552 10.6915 1.67654 10.2573 1.4695 9.72492C1.28816 9.25864 1.28816 8.74132 1.46951 8.27504C1.67655 7.74269 2.25553 7.30846 3.41349 6.43998L9.12015 2.15999Z" fill="url(#1752500502793-639649_layers_existing_1_b23jvecwf)"></path>
                        </clipPath>
                        <mask id="1752500502793-639649_layers_mask_lh5t9hjjm">
                            <rect width="100%" height="100%" fill="#FFF"></rect>
                            <path d="M9.12015 2.15999C10.1529 1.38542 10.6693 0.998128 11.2364 0.848835C11.737 0.717055 12.2632 0.717055 12.7638 0.848834C13.331 0.998124 13.8474 1.38541 14.8801 2.15999L20.5868 6.43998C21.7448 7.30845 22.3238 7.74269 22.5308 8.27503C22.7122 8.74132 22.7122 9.25864 22.5308 9.72492C22.3238 10.2573 21.7448 10.6915 20.5868 11.56L14.8801 15.84C13.8474 16.6146 13.331 17.0019 12.7638 17.1512C12.2632 17.2829 11.737 17.2829 11.2364 17.1512C10.6693 17.0019 10.1529 16.6146 9.12014 15.84L3.41349 11.56C2.25552 10.6915 1.67654 10.2573 1.4695 9.72492C1.28816 9.25864 1.28816 8.74132 1.46951 8.27504C1.67655 7.74269 2.25553 7.30846 3.41349 6.43998L9.12015 2.15999Z" fill="#000"></path>
                        </mask>
                        </defs>
                    </g>
                </svg>
                <h3>多源发掘</h3>
                <span class="subtitle">在不同角落，捕捉任何闪光</span>
            </FadeContent>
        </div>
    </div>
    <div id="container">
        <div v-for="(products, date) in groupedProducts" :key="date">
            <div class="date-wrapper">
                <FadeContent
                    :blur="true"
                    :duration="1000"
                >
                    <div class="date">
                        <span>IN {{ getYear(date) }}</span>
                        <span>{{ getMonthDay(date) }} {{ getWeekday(date) }}</span>
                    </div>
                </FadeContent>
                <div class="products-wrapper">
                    <FadeContent
                        :blur="true"
                        :duration="1000"
                    >
                        <a class="product" v-for="product in products" :key="product.id" :href="product.url"
                            target="_blank" :style="product.style">
                            <SpotlightCard
                                spotlight-color="#5e5c56"
                                style="overflow: hidden; border-radius: 8px;"
                            >
                                <div class="product-content">
                                    <div class="product-info">
                                        <img class="product-icon" :src="product.logo" v-if="product.logo" loading="lazy" @error="onImageError" @load="onImageComplete" />
                                        <div class="product-detail">
                                            <div class="product-name">
                                                <span class="product-name-text">{{ product.name }}</span>
                                                <span class="product-featured-tag" v-if="product.isExcellent" data-tips="编辑精选">
                                                    <i class="ri-thumb-up-fill"></i>
                                                </span>
                                            </div>
                                            <div class="product-desc">{{ product.description }}</div>
                                        </div>
                                        <div class="product-url">
                                            <i class="ri-arrow-right-up-line"></i>
                                        </div>
                                    </div>
                                    <div class="product-img-wrap">
                                        <img class="product-img" :src="product.image" :alt="product.name" loading="lazy" @load="onImageComplete" @error="onImageError">
                                    </div>
                                    <div class="product-bottom">
                                        <div class="product-category-labels">
                                            <div class="product-category">
                                                <i :class="product.categoryIcon"></i>
                                                <span>{{ product.category }}</span>
                                            </div>
                                            <span class="split">|</span>
                                            <div class="product-labels" v-for="label in product.labels">
                                                <span>#{{ label }}</span>
                                            </div>
                                        </div>
                                        <a class="product-source" :class="{ 'no-url': !product.sourceUrl }" :href="product.sourceUrl || undefined" target="_blank">
                                            <span>源自</span>
                                            <img :src="product.sourceIcon" loading="lazy" @load="onImageComplete" @error="onImageError"/>
                                            <span>{{ product.source }}</span>
                                        </a>
                                    </div>
                                </div>
                            </SpotlightCard>
                        </a>
                    </FadeContent>
                </div>
            </div>
        </div>
        <FadeContent
            :blur="true"
            :duration="1000"
        >
            <div class="load-more" v-if="isLoading">
                <div class="loading-animation">
                    <div class="loading-animation-container">
                        <div class="loading-dot"></div>
                        <div class="loading-dot"></div>
                        <div class="loading-dot"></div>
                        <div class="loading-dot"></div>
                        <div class="loading-dot"></div>
                    </div>
                    <svg width="0" height="0" class="svg">
                        <defs>
                            <filter id="uib-jelly-ooze">
                                <feGaussianBlur in="SourceGraphic" stdDeviation="3" result="blur" />
                                <feColorMatrix in="blur" mode="matrix"
                                    values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7" result="ooze" />
                                <feBlend in="SourceGraphic" in2="ooze" />
                            </filter>
                        </defs>
                    </svg>
                </div>
                <span class="loading-tips">LOADING</span>
            </div>
        </FadeContent>
    </div>
    <transition name="fade">
        <div class="overlay" v-show="isMenuOpen" @click="isMenuOpen = false"></div>
    </transition>
    <div class="edge-blur edge-blur-top"></div>
    <div class="edge-blur edge-blur-bottom"></div>
</template>
<script>
    import Prism from "/src/Backgrounds/Prism/Prism.vue";
    import BounceCards from "/src/Components/BounceCards/BounceCards.vue";
    import BlurText from "/src/TextAnimations/BlurText/BlurText.vue";
    import FadeContent from "/src/Animations/FadeContent/FadeContent.vue";
    import AnimatedContent from "/src/Animations/AnimatedContent/AnimatedContent.vue";
    import SpotlightCard from "/src/Components/SpotlightCard/SpotlightCard.vue";
    import Lenis from '@studio-freight/lenis';

    export default {
        name: 'App',
        components: {
            Prism,
            BounceCards,
            BlurText,
            FadeContent,
            AnimatedContent,
            SpotlightCard
        },
        data() {
            return {
                newProducts: [],
                currentIndex: 0,
                groupedProducts: {},
                currentPage: 0,
                pageSize: 20,
                isLoading: false,
                hasMore: true,
                isSticky: false,
                isMenuOpen: false,
                isScrollingUp: false,
                lenis: null,
                sortMode: 'discoveredTime',
                categoryMap: {
                    "娱乐": "ri-movie-2-line",
                    "游戏": "ri-poker-spades-line",
                    "社交": "ri-chat-quote-line",
                    "效率": "ri-stack-line",
                    "办公": "ri-pen-nib-line",
                    "购物": "ri-handbag-line",
                    "生活": "ri-plant-line",
                    "金融": "ri-refund-2-line",
                    "教育": "ri-book-2-line",
                    "健康": "ri-stethoscope-line",
                    "资讯": "ri-receipt-line",
                    "出行": "ri-suitcase-2-line",
                    "体育": "ri-ping-pong-line",
                    "设计": "ri-palette-line",
                    "开发": "ri-puzzle-2-line"
                },
                sourceMap: {
                    1: {
                        name: "V2EX",
                        icon: "https://ik.imagekit.io/Kjaer/Nexplora/source/V2EX.png"
                    },
                    2: {
                        name: "Product Hunt",
                        icon: "https://ik.imagekit.io/Kjaer/Nexplora/source/Product%20Hunt.png"
                    },
                    3: {
                        name: "Reddit",
                        icon: "https://ik.imagekit.io/Kjaer/Nexplora/source/Reddit.png"
                    },
                    4: {
                        name: "Other",
                        icon: "https://ik.imagekit.io/Kjaer/Nexplora/source/Other.png"
                    },
                    5: {
                        name: "Uneed",
                        icon: "https://ik.imagekit.io/Kjaer/Nexplora/source/Uneed.png"
                    },
                    6: {
                        name: "TAAFT",
                        icon: "https://ik.imagekit.io/Kjaer/Nexplora/source/TAAFT.png"
                    },
                    7: {
                        name: "Watcha",
                        icon: "https://ik.imagekit.io/Kjaer/Nexplora/source/Watcha.png"
                    },
                    8: {
                        name: "Y Combinator",
                        icon: "https://ik.imagekit.io/Kjaer/Nexplora/source/Y Combinator.png"
                    },
                    9: {
                        name: "GitHub",
                        icon: "https://ik.imagekit.io/Kjaer/Nexplora/source/GitHub.png"
                    }
                }
            }
        },
        mounted() {
            this.loadMore();
            this.startCarousel();

            this.lenis = new Lenis();
            this.lenis.on('scroll', this.handleScroll);

            const raf = (time) => {
                this.lenis.raf(time);
                requestAnimationFrame(raf);
            };
            requestAnimationFrame(raf);
            
            this.$nextTick(() => {
                if (this.lenis) {
                    this.lenis.resize();
                }
            });
                        
            window.addEventListener('resize', () => {
                this.applyLayout();
                if (this.lenis) {
                    this.lenis.resize();
                }
            });
            window.addEventListener('keydown', this.handleUserInteraction);
            window.addEventListener('wheel', this.handleUserInteraction);
            window.addEventListener('touchstart', this.handleUserInteraction);
        },
        beforeUnmount() {
            if (this.lenis) {
                this.lenis.off('scroll', this.handleScroll);
                this.lenis.destroy();
            }
            window.removeEventListener('keydown', this.handleUserInteraction);
            window.removeEventListener('wheel', this.handleUserInteraction);
            window.removeEventListener('touchstart', this.handleUserInteraction);
        },
        watch: {
            isSticky(newVal) {
                if (!newVal) {
                    this.isMenuOpen = false;
                }
            },
            isMenuOpen(newVal) {
                if (this.lenis) {
                    if (newVal) {
                        this.lenis.stop();
                    } else {
                        this.lenis.start();
                    }
                }
            }
        },
        methods: {
            async fetchProducts() {
                const { data, count, error } = await window.supabase
                    .from('product')
                    .select('*', { count: 'exact', head: false })
                    .eq('isShow', true)
                    .order(this.sortMode, { ascending: false })
                    .order('id', { ascending: false })
                    .range(this.currentPage * this.pageSize, (this.currentPage + 1) * this.pageSize - 1)
                    .limit(this.pageSize)
                
                return { data, count }
            },
            processSupabaseData(products) {
                // 收集已渲染产品的 id，避免后台新增数据导致 position 分页偏移后产生重复
                const existingIds = new Set();
                Object.values(this.groupedProducts).forEach(list => {
                    list.forEach(product => existingIds.add(product.id));
                });
                // 记录本轮新增的 id，防止同一批数据内出现重复
                const batchIds = new Set();

                products.forEach((product, index) => {
                    // 已存在于页面则跳过，避免重复渲染
                    if (existingIds.has(product.id) || batchIds.has(product.id)) return;

                    const date = product.discoveredDate;
                    
                    if (!this.groupedProducts[date]) {
                        this.groupedProducts[date] = [];
                    }
                    
                    const formattedProduct = {
                        id: product.id,
                        logo: product.logo,
                        name: product.name,
                        description: product.description,
                        image: product.image[0],
                        category: product.category,
                        categoryIcon: this.categoryMap[product.category],
                        labels: product.labels,
                        url: product.url,
                        author: product.author,
                        isExcellent: product.isExcellent,
                        source: (this.sourceMap[product.type] || this.sourceMap[4]).name,
                        sourceIcon: (this.sourceMap[product.type] || this.sourceMap[4]).icon,
                        sourceUrl: product.V2EXUrl || product.ProductHuntUrl || product.RedditUrl || product.UneedUrl || product.TAAFTUrl || product.WatchaUrl || product.YCombinatorUrl || product.GitHubUrl || product.discoveredUrl
                    }
                    
                    this.groupedProducts[date].push(formattedProduct);
                    batchIds.add(product.id);

                    if (this.currentPage == 0) {
                        if (formattedProduct.logo) {
                            this.newProducts.push(formattedProduct);
                            this.currentIndex++;
                        }
                        if (index == products.length - 1) {
                            this.currentIndex = 0;
                        }
                    }
                });
            },
            async loadMore() {
                if (this.isLoading || !this.hasMore) return;
                this.isLoading = true;
                
                this.$nextTick(() => {
                    if (this.lenis) {
                        this.lenis.resize();
                    }
                });
                
                const { data: products, count } = await this.fetchProducts();
                this.hasMore = (this.currentPage + 1) * this.pageSize < count
                this.processSupabaseData(products);

                this.currentPage++;
                this.isLoading = false;
                this.$nextTick(() => {
                    this.applyLayout();
                    if (this.lenis) {
                        this.lenis.resize();
                    }
                });
            },
            startCarousel() {
                this.carouselInterval = setInterval(() => {
                    this.currentIndex = (this.currentIndex + 1) % this.newProducts.length;
                }, 3000);
            },
            getYear(discoveredDate) {
                return discoveredDate.split('-')[0];
            },
            getMonthDay(discoveredDate) {
                const [year, month, day] = discoveredDate.split('-');
                return `${month}/${day}`;
            },
            getWeekday(discoveredDate) {
                const weekdays = ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'];
                const date = new Date(discoveredDate);
                return weekdays[date.getDay()];
            },
            applyLayout(dateGroups) {
                const container = document.getElementById('container');
                dateGroups = container.querySelectorAll('.date-wrapper');
                
                dateGroups.forEach(group => {
                    const productsWrapper = group.querySelector('.products-wrapper');
                    const products = productsWrapper.querySelectorAll('.product');
                    const product = products[0];
                    
                    if (!product) return;
                    
                    // 重置产品位置，确保重新计算时不受之前位置影响
                    /*products.forEach(p => {
                        p.style.transform = 'translate3d(0, 0, 0)';
                    });*/   
                    
                    // 强制回流，确保获取正确的offsetWidth
                    void product.offsetWidth;
                    
                    const productWidth = product.offsetWidth + 24;
                    const containerWidth = productsWrapper.offsetWidth;
                    const columnCount = Math.max(1, Math.floor(containerWidth / productWidth));
                    const columnHeights = new Array(columnCount).fill(0);
                    const containerMargin = (containerWidth - (columnCount * productWidth - 24)) / 2;

                    products.forEach(product => {
                        const productSource = product.querySelector('.product-source');
                        const categoryLabels = product.querySelector('.product-category-labels');
                        if (productSource && categoryLabels) {
                            const sourceWidth = productSource.offsetWidth;
                            const bottomWidth = product.querySelector('.product-bottom').offsetWidth;
                            const maxLabelsWidth = bottomWidth - sourceWidth - 16;
                            categoryLabels.style.maxWidth = `${maxLabelsWidth}px`;
                        }
                        
                        const split = product.querySelector('.split');
                        const productLabels = product.querySelectorAll('.product-labels');
                        if (product.offsetWidth < 300) {
                            if (split) split.style.display = 'none';
                            productLabels.forEach(label => label.style.display = 'none');
                        } else {
                            if (split) split.style.display = 'inline';
                            productLabels.forEach(label => label.style.display = 'inline');
                        }
                        
                        const minHeight = Math.min(...columnHeights);
                        const minIndex = columnHeights.indexOf(minHeight);

                        product.style.transform = `translate3d(${minIndex * productWidth + containerMargin}px, ${minHeight}px, 0)`;

                        const height = product.offsetHeight;
                        columnHeights[minIndex] += height + 24;
                    });

                    productsWrapper.style.height = `${Math.max(...columnHeights)}px`;
                });
            },
            onImageComplete(event) {
                const wrap = event.target.parentElement;
                if (wrap && wrap.classList.contains('product-img-wrap')) {
                    wrap.classList.add('loaded');
                }
                this.$nextTick(() => this.applyLayout());
            },
            onImageError(event) {
                const wrap = event.target.parentElement;
                if (wrap && wrap.classList.contains('product-img-wrap')) {
                    wrap.classList.remove('loaded');
                }
                this.$nextTick(() => this.applyLayout());
            },
            handleScroll(e) {
                const pageHeight = document.body.scrollHeight;
                const scrollY = this.lenis ? e.scroll : window.scrollY;
                const scrollToBottom = window.innerHeight + scrollY;

                if (this.isMenuOpen) {
                    this.isMenuOpen = false;
                }

                if (pageHeight - scrollToBottom < 500) {
                    this.loadMore();
                }

                const menu = document.getElementById('menu');
                const menuHeight = menu.offsetHeight;

                this.isSticky = scrollY > menuHeight;

                if (scrollY === 0) {
                    this.isSticky = false;
                }
            },
            handleUserInteraction(event) {
                if (this.isScrollingUp) {
                    if (event.type === 'wheel' || event.type === 'touchstart') {
                        this.isScrollingUp = false;
                    } else if (event.type === 'keydown') {
                        const keyCode = event.keyCode || event.which;
                        if (keyCode === 38 || keyCode === 40 || keyCode === 32) {
                            event.preventDefault();
                            this.isScrollingUp = false;
                        }
                    }
                }
            },
            handleNexRightClick(event) {
                this.sortMode = this.sortMode === 'discoveredTime' ? 'createdTime' : 'discoveredTime';

                if (this.lenis) {
                    this.lenis.scrollTo(0, { immediate: true });
                    // 修复：部分 Lenis 版本 immediate 滚动后内部 stopped/animation 状态未复位，导致滚轮失效
                    this.lenis.start();
                    this.lenis.resize();
                } else {
                    window.scrollTo(0, 0);
                }

                this.currentPage = 0;
                this.hasMore = true;
                this.groupedProducts = {};
                this.newProducts = [];
                this.currentIndex = 0;
                this.loadMore();
            },
            scrollToElement(target) {
                this.isScrollingUp = true;

                this.lenis.scrollTo(target, {
                    duration: 1.2,
                    onComplete: () => {
                        this.isScrollingUp = false;
                    },
                    onError: () => {
                        this.isScrollingUp = false;
                    }
                });
            },
            scrollToProductContainer() {
                const containerElement = document.querySelector('#container');
                if (containerElement) {
                    this.scrollToElement(containerElement);
                }
            },
            scrollToTop() {
                this.isMenuOpen = false;
                if (this.lenis) {
                    this.lenis.start();
                }
                this.scrollToElement(0);
            }
        }
    }
</script>
